module.exports = __webpack_public_path__ + "img/line-big-cta-ap3.c5410c7e.png";